
export const common = {
  // Navigation
  'nav.home': 'Ana Sayfa',
  'nav.treatments': 'Tedaviler',
  'nav.howItWorks': 'Nasıl Çalışır',
  'nav.supervision': 'Gözetim',
  'nav.about': 'Hakkımızda',
  'nav.bookNow': 'Hemen Rezervasyon',
  'nav.language': 'Dil',

  // Hero
  'hero.badge': 'Gerçek doktorlar. Gerçek bakım. Gerçek huzur.',
  'hero.title.line1': 'Gurur Duyacağınız',
  'hero.title.line2': 'Bir Gülüşü Hak Ediyorsunuz',
  'hero.subtitle1': 'İster görmezden geldiğiniz bir ağrı, ister sakladığınız bir gülüş, ister beklemenize neden olan maliyetler olsun — artık beklemenize gerek yok.',
  'hero.subtitle2': 'Türkiye\'de dünya standartlarında diş bakımını güvenli, destekli ve tamamen ulaşılabilir hale getiriyoruz — her adımı izleyen bir doktorla.',
  'hero.cta.primary': 'Yolculuğuma Başla',
  'hero.cta.secondary': 'Önce Biriyle Konuş',
  'hero.feature1': 'Baştan sona doktor gözetimi',
  'hero.feature2': 'Hayatınıza ve bütçenize uygun bakım',
  'hero.feature3': 'Her adımda destekleniyor, yakın ya da uzak',

  // Services
  'services.badge': 'Yolculuğunuz Burada Başlıyor',
  'services.title': 'Her Gün Hislerinizi Değiştiren Tedaviler',
  'services.subtitle': 'Tereddüt etmeden gülmeye, endişe etmeden yemeye veya sadece kendiniz gibi hissetmeye hazır olun — size yardımcı olmak için buradayız',
  'services.cta': 'Tüm Tedavileri Keşfet',
  'services.swipeHint': 'Daha fazla tedavi keşfetmek için kaydırın',
  'services.learnMore': 'Daha Fazla Bilgi',
  'services.startingFrom': 'Başlangıç',
  'services.perTooth': 'diş başına',

  // Service: Dental Implants
  'service.implants.title': 'Diş İmplantı',
  'service.implants.desc': 'Tam güvenle tekrar yiyin, gülün ve konuşun. Doğal dişleriniz gibi görünen, hissettiren ve çalışan dişlerle kendiniz gibi hissedin.',
  // Service: Veneers
  'service.veneers.title': 'Porselen Kaplamalar',
  'service.veneers.desc': 'Fotoğraflarda gülüşünüzü saklamayı bırakın. Her gün aynada gördüğünüzü severek uyanın, sonunda size ait hissettiren bir gülüşle.',

  // Service: Smile Makeover
  'service.smile.title': 'Gülüş Tasarımı',
  'service.smile.desc': 'Kendiniz hakkında hissettiklerinizi dönüştürün. Yüzünüz, hayatınız ve hak ettiğiniz güven etrafında tasarlanmış komple bir gülüş tasarımı.',

  // Service: Orthodontics
  'service.orthodontics.title': 'Ortodonti',
  'service.orthodontics.desc': 'Dişlerinizi özgüven kaybı olmadan düzeltin. Yaşam tarzınıza uyan ve her zaman istediğiniz gülüşü veren gizli tedavi.',

  // Service: Whitening
  'service.whitening.title': 'Diş Beyazlatma',
  'service.whitening.desc': 'Her konuşmada kendinize güvenin. Her konuştuğunuzda kendinizi iyi hissettiren daha parlak, daha beyaz bir gülüş.',

  // Service: Root Canal
  'service.root.title': 'Kanal Tedavisi',
  'service.root.desc': 'Diş ağrısıyla yaşamayı bırakın. Doğal dişinizi kurtarın ve sürekli rahatsızlık veya endişe olmadan hayatın tadını çıkarmaya geri dönün.',

  // Service: Crowns
  'service.crowns.title': 'Diş Kronları',
  'service.crowns.desc': 'Hasarlı dişleri koruyun ve restore edin, böylece sevdiğiniz şeyleri tekrar yiyebilirsiniz. Yıllarca dayanacak güçlü, doğal görünümlü kronlar.',

  // Service: All-on-4
  'service.allon4.title': 'All-on-4 İmplantlar',
  'service.allon4.desc': 'Hayatınızı sadece bir günde geri alın. Sınır veya utanç olmadan yemenize, gülmenize ve yaşamanıza izin veren tam bir kalıcı diş seti.',

  // How It Works
  'how.badge': 'Basit Süreç',
  'how.title': 'Nasıl Çalışır',
  'how.subtitle': 'Tam şeffaflıkla dünya standartlarında diş bakımı için dört basit adım',
  'how.cta': 'Yolculuğunuza Başlayın',

  'how.step1.number': '01',
  'how.step1.title': 'Tedavinizi Rezerve Edin',
  'how.step1.desc': 'Diş tedavinizi seçin ve röntgenlerinizi veya taramalarınızı yükleyin. Ekibimiz inceleyecek ve kişiselleştirilmiş bir tedavi planı oluşturacak.',

  'how.step2.number': '02',
  'how.step2.title': 'Gözetim Seçin',
  'how.step2.desc': 'Tercih ettiğiniz gözetim seçeneğini seçin: bağımsız üçüncü taraf doktor, kendi diş hekiminiz (%10 alır) veya kendi uzmanımız.',

  'how.step3.number': '03',
  'how.step3.title': 'Şeffaflıkla Tedavi Olun',
  'how.step3.desc': 'JCI akrediteli kliniğimizde tedavinizi alın. Seçtiğiniz gözetmen tüm röntgenleri, taramaları ve tedavi ilerlemesini gerçek zamanlı olarak inceler.',

  'how.step4.number': '04',
  'how.step4.title': 'Takip Bakımı',
  'how.step4.desc': 'Tedaviniz hakkında tam bilgiye sahip diş hekiminizle bakıma devam edin. Tüm kayıtları ve sürekli desteği sağlıyoruz.',

  // Supervision
  'supervision.badge': 'Her Adımda Korunuyorsunuz',
  'supervision.title': 'Diş Bakımı İçin Yurt Dışına Gitmekten Endişeli misiniz?',
  'supervision.subtitle': 'Bu endişe tamamen geçerli — ve tam olarak bu yüzden bunu inşa ettik. Her hasta, tedavisini ilk günden bitişe kadar izleyen özel bir gözetmene sahip olur.',
  'supervision.swipeHint': 'Seçenekleri keşfetmek için kaydırın',
  'supervision.chooseOption': 'Rezervasyon yaparken bu seçeneği seçin',

  'supervision.option1.title': 'Bağımsız Üçüncü Taraf Doktor',
  'supervision.option1.badge': 'En Güvenilir',
  'supervision.option1.desc': 'Sadece size cevap veren biri — kliniğe değil. Her taramayı incelerler, her adımı onaylarlar ve hiçbir şeyin kaçırılmadığından emin olurlar.',
  'supervision.option1.feature1': 'Herhangi bir şey başlamadan önce röntgenlerinizi inceler',
  'supervision.option1.feature2': 'Tedavi planınızı bağımsız olarak onaylar',
  'supervision.option1.feature3': 'Bakımınızın her aşamasında kontrol eder',
  'supervision.option1.feature4': 'Nihai sonucun standarda uygun olduğunu doğrular',
  'supervision.option1.feature5': 'Sıfır çıkar çatışması — sizin için çalışırlar',
  'supervision.option1.pricing': 'Ne elde edersiniz: Tam bağımsız gözetim',

  'supervision.option2.title': 'Kendi Ülkenizdeki Doktorunuz',
  'supervision.option2.badge': 'En Rahat',
  'supervision.option2.desc': 'Zaten güvendiğiniz diş hekimi yolculuğunuzun bir parçası olmaya devam eder. Geçmişinizi bilirler, sizi tanırlar — ve her adımda bilgilendirilirler.',
  'supervision.option2.feature1': 'Diş hekiminiz tüm kayıtları ve taramaları alır',
  'supervision.option2.feature2': 'Her tedavi aşamasında bilgilendirilir',
  'supervision.option2.feature3': 'Ülkenizdeki takip bakımınızı üstlenir',
  'supervision.option2.feature4': 'Zamanı için tedavi maliyetinin %10\'unu kazanır',
  'supervision.option2.feature5': 'Kesintisiz süreklilik — yeniden başlama yok',
  'supervision.option2.pricing': 'Ne elde edersiniz: Tanıdık bakım, boşluk yok',

  'supervision.option3.title': 'Kendi Uzmanımız',
  'supervision.option3.badge': 'Dahil',
  'supervision.option3.desc': '15+ yıl deneyime sahip kıdemli bir uzman, tedavinizi yerinde izler. Asla sadece bir hasta değilsiniz — bir önceliksiniz.',
  'supervision.option3.feature1': '15+ yıl uzman deneyimi',
  'supervision.option3.feature2': 'Bakımınız boyunca klinikte hazır bulunur',
  'supervision.option3.feature3': 'Bir şey yanlış hissedilirse hemen yanıt verir',
  'supervision.option3.feature4': 'Her adımı en yüksek standartta tutar',
  'supervision.option3.feature5': 'Zaten dahil — size ekstra maliyet yok',
  'supervision.option3.pricing': 'Ne elde edersiniz: Uzman gözler, her zaman mevcut',

  'supervision.why.title': 'Sadece En İyisini Ummak Zorunda Kalmamalısınız',
  'supervision.why.desc': 'Diş tedavisi için yurt dışına gitmek cesaret gerektirir. Hiç tanışmadığınız insanlara, belki de bilmediğiniz bir ülkede, gülüşünüz kadar kişisel bir şeyle güveniyorsunuz. Gözetim sistemimizi inşa ettik çünkü bir vaadden fazlasını hak ettiğinize inanıyoruz — bakımınızla ilgili verilen her kararı izleyen gerçek bir insanı hak ediyorsunuz. Bir kontrol listesi değil. Bir broşür değil. Size karşı sorumlu olan bir insan.',

  // CTA
  'cta.title.line1': 'Gülüşünüz',
  'cta.title.line2': 'Yeterince Uzun Bekledi',
  'cta.subtitle1': 'Bu adımı atmanın kolay olmadığını biliyoruz. Belirsizlik, sorular, "ya" lar — her gün duyuyoruz. Tam olarak bu yüzden buradayız.',
  'cta.subtitle2': 'İlk görüşmeniz ücretsiz, baskısız ve tamamen sizin şartlarınızda. Sadece bizimle konuşun — gerisini biz hallederiz.',
  'cta.button.primary': 'Konuşmaya Hazırım',
  'cta.button.secondary': 'WhatsApp\'ta Sohbet Et',
  'cta.badge1': 'Gerçek doktorlar. Gerçek bakım.',
  'cta.badge2': 'Baskı yok. Acele yok.',
  'cta.badge3': 'Her adımda destekleniyorsunuz.',
  'cta.badge4': 'Gerçek sonuçlar. Gerçek insanlar.',

  // Footer
  'footer.brand.desc': 'Herkesin gülüşünde kendine güvenmesi gerektiğine inanıyoruz. Bunu mümkün kılmak için buradayız — güvenli, dürüst ve yanınızda gerçek bir doktorla.',
  'footer.cta': 'Danışma Rezervasyonu',
  'footer.treatments': 'Tedaviler',
  'footer.company': 'Şirket',
  'footer.resources': 'Kaynaklar',
  'footer.phone': 'Telefon',
  'footer.email': 'E-posta',
  'footer.location': 'Konum',
  'footer.locationValue': 'İstanbul, Türkiye',
  'footer.copyright': '© {{year}} Plexus Alliance. Tüm hakları saklıdır.',
  'footer.poweredBy': 'Readdy tarafından desteklenmektedir',

  // About page
  'about.hero.badge': 'Hikayemiz',
  'about.hero.title': 'Diş Turizminin Eksik Olduğu Güvenlik Ağını Biz Kurduk',
  'about.hero.subtitle': 'Plexus Alliance basit bir inançla kuruldu: Hastalar kendi tedavilerinde bağımsız bir sese hak kazanır — özellikle evden uzaktayken.',
  'about.mission.badge': 'Misyonumuz',
  'about.mission.title': 'Her yerde her hasta için şeffaf, denetimli diş bakımı.',
  'about.mission.desc': 'Hastaları İstanbul\'daki dünya standartlarındaki diş klinikleriyle buluştururken, çoğu diş turizmi şirketinin sunmadığı bağımsız denetim katmanını sağlıyoruz.',
  'about.values.badge': 'Neye İnanıyoruz',
  'about.values.title': 'Temel Değerlerimiz',
  'about.value1.title': 'Bağımsızlık',
  'about.value1.desc': 'Gözetmenlerimiz yalnızca size cevap verir — kliniğe değil.',
  'about.value2.title': 'Şeffaflık',
  'about.value2.desc': 'Her kayıt, her tarama, her karar — size tamamen görünür.',
  'about.value3.title': 'Süreklilik',
  'about.value3.desc': 'Bakımınız eve dönen uçağa bindiğinizde durmuyor.',
  'about.value4.title': 'Erişilebilirlik',
  'about.value4.desc': 'Dünya standartlarında diş bakımı bir ayrıcalık olmamalı. Biz onu ulaşılabilir kılıyoruz.',

  // Treatments page
  'treatments.hero.badge': 'Tüm Tedaviler',
  'treatments.hero.title': 'Tedavinizi Bulun',
  'treatments.hero.subtitle': 'Tek implanttan tam gülüş tasarımına — her tedavi denetimli, şeffaf ve adil fiyatlı.',
  'treatments.filter.all': 'Tüm Tedaviler',
  'treatments.filter.implants': 'İmplantlar',
  'treatments.filter.cosmetic': 'Kozmetik',
  'treatments.filter.orthodontics': 'Ortodonti',
  'treatments.filter.restorative': 'Restoratif',
  'treatments.cta.title': 'Hangi tedaviye ihtiyacınız olduğundan emin değil misiniz?',
  'treatments.cta.desc': 'Bize neyin sizi rahatsız ettiğini söyleyin — vakanızı ücretsiz inceleyip doğru yolu önereceğiz.',
  'treatments.cta.button': 'Ücretsiz Değerlendirme Alın',

  // Book Treatment page
  'book.hero.badge': 'Yolculuğunuzu Başlatın',
  'book.hero.title': 'Tedavinizi Rezerve Edin',
  'book.hero.subtitle': 'Aşağıdaki bilgileri doldurun, birkaç saat içinde kişiselleştirilmiş bir planla size geri döneceğiz.',
  'book.form.name': 'Ad Soyad',
  'book.form.email': 'E-posta Adresi',
  'book.form.phone': 'Telefon / WhatsApp',
  'book.form.treatment': 'İlgilendiğiniz Tedavi',
  'book.form.supervision': 'Gözetim Tercihi',
  'book.form.message': 'Daha fazla bilgi verin (isteğe bağlı)',
  'book.form.submit': 'Talebimi Gönder',
  'book.form.submitting': 'Gönderiliyor...',
  'book.form.success': 'Talep gönderildi! Birkaç saat içinde sizinle iletişime geçeceğiz.',

  // Partner Registration page
  'partner.hero.badge': 'Bizimle Ortak Olun',
  'partner.hero.title': 'Plexus Alliance Ağına Katılın',
  'partner.hero.subtitle': 'Diş hekimi, klinik veya sağlık uzmanı mısınız? Bizimle ortak olun ve hastalarınızın dünya standartlarında bakıma erişmesine yardımcı olurken kazanın.',
  'partner.form.submit': 'Başvuruyu Gönder',

  // How It Works page
  'hiw.hero.badge': 'Süreç',
  'hiw.hero.title': 'Nasıl Çalışır',
  'hiw.hero.subtitle': 'İlk mesajınızdan son kontrolünüze — adım adım tam olarak ne olduğu burada.',
  'hiw.faq.title': 'Hâlâ sorularınız mı var?',
  'hiw.cta.title': 'İlk adımı atmaya hazır mısınız?',
  'hiw.cta.subtitle': 'Tek bir mesajla başlar. Neye ihtiyacınız olduğunu söyleyin — gerisini biz hallederiz.',
  'hiw.cta.button': 'Yolculuğumu Başlat',

  // Supervision page
  'sup.hero.badge': 'Korumanız',
  'sup.hero.title': 'Tıbbi Gözetim',
  'sup.hero.subtitle': 'Çoğu diş turizmi şirketinin sunmadığı tek şey — ve tüm farkı yaratan tek şey.',
  'sup.why.title': 'Çoğu klinik kendisi için çalışır. Biz sizin için çalışırız.',
  'sup.options.title': 'Korunmanın üç yolu',
  'sup.pillars.title': 'Gözetim altındaki her hastanın aldığı şey',
  'sup.compare.title': 'Gözetimle ve gözetimsiz',
  'sup.faq.title': 'Gözetim hakkında sorular',
  'sup.cta.title': 'Sağlığınız bağımsız bir sesi hak ediyor.',
  'sup.cta.button': 'Gözetimle Rezervasyon Yap',

  // Common UI
  'common.learnMore': 'Daha Fazla Bilgi',
  'common.bookNow': 'Hemen Rezervasyon',
  'common.startJourney': 'Yolculuğumu Başlat',
  'common.getStarted': 'Başla',
  'common.contactUs': 'Bize Ulaşın',
  'common.readMore': 'Devamını Oku',
  'common.viewAll': 'Tümünü Gör',
  'common.close': 'Kapat',
  'common.back': 'Geri',
  'common.next': 'İleri',
  'common.loading': 'Yükleniyor...',
  'common.error': 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
  'common.required': 'Bu alan zorunludur',
  'common.optional': 'İsteğe bağlı',
  'common.saving': 'Tasarruf',
  'common.perTooth': 'diş başına',
  'common.included': 'Dahil',
  'common.mostTrusted': 'En Güvenilir',
  'common.mostComfortable': 'En Rahat',
  'common.yearsExperience': 'yıl deneyim',
  'common.patients': 'hasta',
  'common.countries': 'ülke',
  'common.savings': 'tasarruf',
};

export default common;
